import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { connect } from "react-redux";
import { Field, reduxForm, reset, formValueSelector } from "redux-form";
import {
  insertSponsor,
  openSponsorModal,
  loadSponsorData,
  openMembershipModal,
  editSponsorCategory,
  addSponsorCategory,
  updateSponsorCategory,
} from "ActionsSponsors";
import { Modal, Row, Col, Tabs, Tab } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import {
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  COMMON_FAIL_MESSAGE,
  maxLengthObjectFc, // MAX character validation
} from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { IMAGE_PATH } from "Constants";
import { SketchPicker } from "react-color";
import { withRouter } from "react-router-dom";
import LocaleStrings from "Languages";

var MAXLENOBJ = {}; // MAX character validation

class CategoryForm extends Component {
  constructor(props) {
    super(props);

    var { bgcolor, textcolor, membershiptitle } = props.initialValues;
    this.state = {
      loading: false,
      textColor: textcolor,
      textColorPickerVisible: false,
      bgColor: bgcolor,
      bgColorPickerVisible: false,
      title: membershiptitle,
    };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  renderFieldText(field) {
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    return (
      <div className={divClassName} style={{ position: "relative" }}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            min={field.min ? field.min : ""}
            maxLength={field.maxlength ? field.maxlength : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>

          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderColorFieldText(field) {
    var selectedColor = field.input.value;
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-1 col-sm-offset-0 categoryHiddenField";

    return (
      <div className={divClassName}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
        <div className="col-sm-2">
          <div
            className="category-color-pallete"
            style={{ backgroundColor: `${selectedColor}` }}
          ></div>
        </div>
        <div className="col-sm-2" style={{ paddingLeft: 0 }}>
          <div
            className="category-color-pallete-picker"
            onClick={field.openColorPicker}
          >
            <i
              className="fa fa-eyedropper"
              style={{ fontSize: 18, padding: 6 }}
            ></i>
          </div>
          {field.pickerVisible && (
            <div style={{ position: "absolute", zIndex: 2000 }}>
              <SketchPicker
                color={selectedColor}
                onChangeComplete={field.handleColorChange}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  onFormSubmit = (values) => {
    var title = values.membershiptitle.trim();
    if (title.length === 0) title = values.membershiptype;

    var dicValues = {
      ...values,
      membershiptype: values.membershiptype.toLowerCase(),
      membershiptitle: title.toUpperCase(),
    };
    this.setState({ loading: true });
    if (this.props.edit) {
      this.props.updateSponsorCategory(
        dicValues,
        this.props.session,
        (response) => {
          if (response.error === 0) {
            this.props.showSuccess("Category updated Successfully");
            this.props.editSponsorCategory({ toAdd: false, toEdit: false });
            this.props.operationsCallback();
            this.props.reset();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
          this.setState({ loading: false });
        }
      );
    } else {
      this.props.addSponsorCategory(
        dicValues,
        this.props.session,
        (response) => {
          if (response.error === 0) {
            this.props.showSuccess("Category created Successfully");
            this.props.editSponsorCategory({ toAdd: false, toEdit: false });
            this.props.operationsCallback();
            this.props.reset();
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
          this.setState({ loading: false });
        }
      );
    }
  };

  openTextColorPickerAction = () => {
    this.setState({
      textColorPickerVisible: !this.state.textColorPickerVisible,
    });
  };

  handleTextColorChangeAction = ({ hex }) => {
    this.setState({ textColor: hex });
    this.props.change("textcolor", hex);
  };

  openBGColorPickerAction = () => {
    this.setState({ bgColorPickerVisible: !this.state.bgColorPickerVisible });
  };

  handleBGColorChangeAction = ({ hex }) => {
    this.setState({ bgColor: hex });
    this.props.change("bgcolor", hex);
  };

  onTitleChange = (e) => {
    this.setState({ title: e.target.value });
  };

  close = () => {
    this.props.editSponsorCategory({ toAdd: false, toEdit: false });
  };

  render() {
    var { handleSubmit, pristine, dirty, reset, submitting, valid } =
      this.props;
    var { textColor, bgColor, title } = this.state;
    var edit = this.props.edit;

    var disabled = !((dirty && valid) || (edit && pristine));
    return (
      <div className="basicform" style={{ padding: 20 }}>
        <div className="row">
          <div className="col-sm-8">
            <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
              <Field
                name="membershiptype"
                label={LocaleStrings.sponsor_label_membershiptype}
                placeholder={LocaleStrings.sponsor_placeholder_membershiptype}
                type="text"
                component={this.renderFieldText}
                mandatory="true"
              />
              <Field
                name="membershiptitle"
                label={LocaleStrings.sponsor_label_membershiptitle}
                placeholder={LocaleStrings.sponsor_placeholder_membershiptitle}
                type="text"
                component={this.renderFieldText}
                mandatory="false"
                onChange={this.onTitleChange}
                maxlength={MAXLENOBJ.membershiptitle}
              />
              <Field
                name="bgcolor"
                label={LocaleStrings.sponsor_label_bgcolor}
                placeholder={LocaleStrings.sponsor_placeholder_bgcolor}
                type="text"
                component={this.renderColorFieldText}
                mandatory="true"
                pickerVisible={this.state.bgColorPickerVisible}
                openColorPicker={this.openBGColorPickerAction}
                handleColorChange={this.handleBGColorChangeAction}
              />
              <Field
                name="textcolor"
                label={LocaleStrings.sponsor_label_textcolor}
                placeholder={LocaleStrings.sponsor_placeholder_textcolor}
                type="text"
                component={this.renderColorFieldText}
                mandatory="true"
                pickerVisible={this.state.textColorPickerVisible}
                openColorPicker={this.openTextColorPickerAction}
                handleColorChange={this.handleTextColorChangeAction}
              />
              <Field
                name="priorityindex"
                label={LocaleStrings.sponsor_label_priority}
                placeholder={LocaleStrings.sponsor_placeholder_priorty}
                type="number"
                component={this.renderFieldText}
                mandatory="false"
                min="1"
              />
              <div className="row">
                <div className="col-sm-3">&nbsp;</div>
                <div
                  className="text-help label-text-help col-sm-9 col-sm-offset-0"
                  style={{ color: "#4da1ff", marginTop: -15 }}
                >
                  Note - Higher the value lower the priority
                </div>
              </div>
              <div className="buttonsFooter">
                <Button
                  className="btn btn-custom-white"
                  style={{ marginRight: 10 }}
                  onClick={this.close}
                >
                  Close
                </Button>

                <Button
                  className="button-theme button-theme-blue"
                  bsStyle="primary"
                  loading={this.state.loading}
                  type="submit"
                  disabled={disabled}
                >
                  Save Changes
                </Button>
              </div>
            </form>
          </div>
          <div className="col-sm-4">
            <div>
              <div className="previewStyle">
                {LocaleStrings.sponsor_preview}
              </div>
              <div className="shape-left">
                <div className="triangle-left"></div>
                <div
                  className="square-left-fixed-width"
                  style={{
                    color: textColor,
                    background: bgColor,
                  }}
                >
                  {title.toUpperCase()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var requiredFields = ["textcolor", "bgcolor", "membershiptype"];

  var maxLengthFields = ["membershiptitle"]; // MAX character validation

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
    if (field === "membershiptype") {
      if (values[field] && !/^\S*$/.test(values[field])) {
        errors[field] = "Category type should not contain space.";
      } else if (values[field] && !/^[a-zA-Z0-9- ]*$/.test(values[field])) {
        errors[field] = "Category type contains special characters.";
      }
    }
  });

  if (values.priorityindex < 1) {
    errors.priorityindex = "Priority can not be less than 1.";
  }

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
}

function mapStateToProps(state) {
  var initValues = state.editSponsorCategory;
  var { bgcolor, textcolor, membershiptitle } = initValues;
  if (membershiptitle === undefined) membershiptitle = "";
  if (bgcolor === undefined) bgcolor = "#555555";
  if (textcolor === undefined) textcolor = "#ffffff";
  initValues = { ...initValues, bgcolor, textcolor, membershiptitle };
  return {
    session: state.session,
    showModal: state.sponsorModal,
    initialValues: initValues,
    edit: state.editSponsorCategory.toEdit,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    showError,
    showSuccess,
    editSponsorCategory,
    addSponsorCategory,
    updateSponsorCategory,
  })(
    reduxForm({
      validate,
      form: "CategoryForm",
      enableReinitialize: true,
      keepDirtyOnReinitialize: true,
    })(CategoryForm)
  )
);
